// PDF Parts
import { Body } from "./Body";

// Redux
import { useSelector } from "react-redux";
import { RootState } from "store";

export const PDFLaborOld: React.FC = () => {
  const certificates = useSelector(
    (state: RootState) => state.ordsReducer.certificates
  );

  return (
    <>
      <Body data={certificates} />
    </>
  );
};
